export const BackToSchool = () => {
    return (
      <section id="BackToSchool">
        <div className="banner_bts" >
        <div className="banner__content">
          <div className="txt">
            <div className="txt__content" id='banner-text'>
              {/* <img className="montana" src="https://res.cloudinary.com/lippi-outdoor/image/upload/v1657290075/banner-lippi/MONTANA_hhsbdh.png" alt="" /> */}
              {/* <div className="line"></div> 
                <h1><strong>WINTER SAL<span>E</span></strong></h1>*/}
              {/* <img className="logo-lippi" src="https://res.cloudinary.com/lippi-outdoor/image/upload/v1659713675/home-lippi/winter-sale/Logo_lippi_quliiz.png" alt="" />
              <h1>QUE LA AVENTURA</h1>
              <h1><strong>CONTINÚE</strong></h1> */}
              <img className="logo-lippi" src="https://res.cloudinary.com/lippi-outdoor/image/upload/v1669341577/black-friday/Lippi/lippi-logo_qmi0qm.png" alt="" />
              <h1>CON ELLOS EN TODAS</h1>
              <p>ABRÍGATE CON NUESTRA NUEVA TEMPORADA Y SORPRÉNDETE <br></br>CON COLORES Y DISEÑOS ÚNICOS PARA TUS PRÓXIMAS AVENTURAS</p>
              <div className="btn-white">
                <a href="https://www.lippioutdoor.com/oto-o.html" target='_parent' id="C0.1">Productos</a>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>
    )
  }